import { c as _c } from "react/compiler-runtime";
import { DateRangePicker } from '@systemeio/components';
import { CurrencyEnum } from '@systemeio/types';
import { cents, centsToUnits } from '@systemeio/util';
import { FunnelStatisticsFilterInterface } from 'modules/funnels/funnel/types/funnel-statistics-interface';
import React, { type JSX } from 'react';
import { FilterHeader } from 'shared/components/filter-header';
import { toFilterGroup, useFilterDraft } from 'shared/hooks/use-filter-draft';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
import { getDatePickerMinDate } from 'shared/utils/get-date-picker-min-date';
interface StatisticsTabTableLayoutProps {
  setFilter: React.Dispatch<React.SetStateAction<FunnelStatisticsFilterInterface>>;
  filter: FunnelStatisticsFilterInterface;
  currency: CurrencyEnum;
  totalSales: number | null;
  averageCartValue: number | null;
  children: JSX.Element;
}
function StatisticsTabTableLayout(t0) {
  const $ = _c(55);
  const {
    filter,
    setFilter,
    currency,
    totalSales,
    averageCartValue,
    children
  } = t0;
  const {
    user,
    intlLocale
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      date: [null, null]
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const defaults = t1;
  let t2;
  if ($[1] !== setFilter) {
    t2 = values => setFilter(values);
    $[1] = setFilter;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== filter || $[4] !== t2) {
    t3 = {
      applied: filter,
      defaults,
      onApply: t2
    };
    $[3] = filter;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const state = useFilterDraft(t3);
  let t4;
  if ($[6] !== t) {
    t4 = t("dashboard.funnel.statistics.gross");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <div className="text-large">{t4}</div>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== currency || $[11] !== totalSales || $[12] !== user?.dashboardLocale) {
    t6 = currencyFormat(centsToUnits(cents(totalSales || 0)), currency, user?.dashboardLocale);
    $[10] = currency;
    $[11] = totalSales;
    $[12] = user?.dashboardLocale;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <div className="text-text-link text-3xl font-medium">{t6}</div>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = <div className="bg-bg-primary border-table-cell-border flex w-full flex-col gap-2 rounded-xl border px-6 py-3">{t5}{t7}</div>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("dashboard.funnel.statistics.average_cart_value");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t9) {
    t10 = <div className="text-large">{t9}</div>;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== averageCartValue || $[24] !== currency || $[25] !== user?.dashboardLocale) {
    t11 = currencyFormat(centsToUnits(cents(averageCartValue || 0)), currency, user?.dashboardLocale);
    $[23] = averageCartValue;
    $[24] = currency;
    $[25] = user?.dashboardLocale;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11) {
    t12 = <div className="text-text-link text-3xl font-medium">{t11}</div>;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t10 || $[30] !== t12) {
    t13 = <div className="bg-bg-primary border-table-cell-border flex w-full flex-col gap-2 rounded-xl border px-6 py-3">{t10}{t12}</div>;
    $[29] = t10;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13 || $[33] !== t8) {
    t14 = <div className="desktop:gap-5 grid grid-cols-2 items-end gap-3">{t8}{t13}</div>;
    $[32] = t13;
    $[33] = t8;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const t15 = state.draft.date;
  let t16;
  if ($[35] !== state) {
    t16 = date => {
      state.setDraft({
        date
      });
    };
    $[35] = state;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const t17 = user?.timezone;
  const t18 = user?.createdAt;
  const t19 = user?.timezone;
  let t20;
  if ($[37] !== t18 || $[38] !== t19) {
    t20 = getDatePickerMinDate(t18, t19);
    $[37] = t18;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== intlLocale || $[41] !== state.draft.date || $[42] !== t16 || $[43] !== t17 || $[44] !== t20) {
    t21 = <DateRangePicker date={t15} onChange={t16} timezone={t17} minDate={t20} intlLocale={intlLocale} />;
    $[40] = intlLocale;
    $[41] = state.draft.date;
    $[42] = t16;
    $[43] = t17;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== state || $[47] !== t21) {
    t22 = toFilterGroup(state, [{
      key: "date",
      node: t21
    }]);
    $[46] = state;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t22) {
    t23 = <FilterHeader filters={t22} />;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== children || $[52] !== t14 || $[53] !== t23) {
    t24 = <div className="desktop:gap-5 tablet:gap-4 flex flex-col gap-3">{t14}{t23}{children}</div>;
    $[51] = children;
    $[52] = t14;
    $[53] = t23;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  return t24;
}
export default StatisticsTabTableLayout;